export const WorktreeRibbon: React.FC = () => {
  const branch = import.meta.env.VITE_WORKTREE_BRANCH;

  if (!branch) return null;

  return (
    <div className="fixed top-2 right-2 z-50 pointer-events-none">
      <div className="bg-mxa-orange text-white text-xs font-semibold px-3 py-1 rounded-full shadow-lg">
        {branch}
      </div>
    </div>
  );
};
